function B2B_Price_Component_Initializer() {
  function manageThumbnailOrder() {
    const sectionId = document.querySelector('.b2b-product-block')?.dataset.sectionId;
    const thumbnailContainer = document.getElementById('Product-Thumbnails');
    const mediaDataScript = document.getElementById('b2b-product-media-json');
    if (!sectionId || !thumbnailContainer || !mediaDataScript || thumbnailContainer.dataset.b2bFixed) return;
    const correctMediaOrder = JSON.parse(mediaDataScript.textContent);
    const correctThumbIds = correctMediaOrder.map(media => `Thumb-${sectionId}-${media.id}`);
    const currentThumbnails = Array.from(thumbnailContainer.children);
    const sortedThumbnails = correctThumbIds.map(id => currentThumbnails.find(thumb => thumb.id === id)).filter(Boolean);
    sortedThumbnails.forEach(thumb => thumbnailContainer.appendChild(thumb));
    thumbnailContainer.dataset.b2bFixed = 'true';
  }

  if (!window.B2BTieredPricing) {
    window.B2BTieredPricing = class B2BTieredPricing {
      constructor(container) {
        this.container = container;
        if (!this.container || this.container.dataset.initialized) return;
        this.container.dataset.initialized = true;
        this.cacheDOMElements();
        if (!this.skuListBody) return;
        this.allVariantData = this.parseJsonData(document.querySelector('variant-selects')?.querySelector('[type="application/json"]'));
        const tiersJsonEl = this.container.querySelector('[data-progress-tiers-json]');
        this.progressTiers = this.parseJsonData(tiersJsonEl, []);
        this.bindEvents();
        this.fetchCartAndInitialize();
        this.initFancybox();
        this.handleUrlVariantOnLoad(); 
      }

      cacheDOMElements() {
        this.currencyCode = this.container.dataset.currencyCode;
        this.sectionId = this.container.dataset.sectionId;
        this.skuListBody = this.container.querySelector('.sku-list-body');
        this.skuItems = this.container.querySelectorAll('.sku-item');
        this.totalItemsEl = this.container.querySelector('.js-total-items-count');
        this.totalPriceEl = this.container.querySelector('.js-total-price-value');
        this.addToCartBtn = this.container.querySelector('.b2b-add-to-cart-button');
        this.galleryContainer = document.getElementById('MediaGallery-' + this.sectionId);
        this.productSliderElement = document.getElementById('Product-Slider');
        this.priceElement = document.getElementById(`price-${this.sectionId}`);
        this.skuElement = document.getElementById(`sku-${this.sectionId}`);
        this.productFormInput = document.querySelector(`#product-form-${this.sectionId} input[name="id"]`);
        this.cartTotalCents = 0;
        this.progressBar = this.container.querySelector('.progress-v4-bar-fill');
        this.currentValueDisplay = this.container.querySelector('.progress-v4-current-value');
        this.milestones = this.container.querySelectorAll('.progress-v4-step');
      }

      async fetchCartAndInitialize() {
        try {
          const response = await fetch('/cart.js');
          if (!response.ok) throw new Error('Network response was not ok');
          const cart = await response.json();
          this.cartTotalCents = cart.total_price || 0;
        } catch (error) { console.error('B2B Block: Failed to fetch cart.', error); this.cartTotalCents = 0; } 
        finally { this.updateAll(); }
      }
      
      parseJsonData(element, fallback = []) {
        if (!element) return fallback;
        try { return JSON.parse(element.textContent); } catch (e) { console.error('B2B Tiered Pricing: Could not parse JSON data.', e); return fallback; }
      }
      
      // ########## RESTORED: Handle variant linking on page load ##########
      handleUrlVariantOnLoad() {
        const urlParams = new URLSearchParams(window.location.search);
        const variantIdFromUrl = urlParams.get('variant');
        if (!variantIdFromUrl) return;
        const targetSkuItem = this.container.querySelector(`.sku-item[data-variant-id="${variantIdFromUrl}"]`);
        if (targetSkuItem) {
          requestAnimationFrame(() => {
            this.toggleSkuHighlight(targetSkuItem, false);
          });
        }
      }

      initFancybox() { if (typeof Fancybox !== 'undefined') { Fancybox.bind(`[data-block-id="${this.container.dataset.blockId}"] [data-fancybox]`, { groupAll: true, caption: (fancybox, slide) => slide.triggerEl?.dataset.caption || null }); } else { console.warn('B2B BLOCK: Fancybox library is not loaded.'); } }
      
      bindEvents() {
        this.skuListBody.addEventListener('click', this.handleSkuListClick.bind(this));
        this.skuListBody.addEventListener('input', this.handleQuantityInputChange.bind(this));
        this.addToCartBtn.addEventListener('click', this.handleAddToCart.bind(this));
        if (this.galleryContainer) { this.galleryContainer.addEventListener('click', this.handleThumbnailClick.bind(this)); }
      }
      
      handleThumbnailClick(event) {
        const clickedThumb = event.target.closest('.product-thumbnail');
        if (!clickedThumb || !this.allVariantData) return;
        const mediaId = clickedThumb.id.split('-').pop();
        if (!mediaId) return;
        const linkedVariant = this.allVariantData.find(v => v.featured_media && v.featured_media.id == mediaId);
        if (!linkedVariant) return;
        const targetSkuItem = this.container.querySelector(`.sku-item[data-variant-id="${linkedVariant.id}"]`);
        if (targetSkuItem && !targetSkuItem.classList.contains('is-highlighted')) {
            this.toggleSkuHighlight(targetSkuItem, true, false);
        }
      }

      handleSkuListClick(event) {
        const skuItem = event.target.closest('.sku-item');
        if (!skuItem) return;
        if (event.target.closest('.sku-image-link')) return;
        if (event.target.matches('.qty-btn')) {
          event.preventDefault();
          event.stopPropagation();
          this.handleQuantityButtonClick(event.target);
          return;
        }
        if (!event.target.closest('.sku-quantity-control')) { this.toggleSkuHighlight(skuItem); }
      }
      
      syncVisualState(variantId) { 
        if (!variantId || !this.allVariantData) return;
        const targetVariant = this.allVariantData.find(v => v.id == variantId);
        if (!targetVariant) return;
        
        if (this.productFormInput) this.productFormInput.value = targetVariant.id;
        if (this.skuElement) this.skuElement.textContent = targetVariant.sku || '';
        if (this.priceElement) {
            const priceWrapper = this.priceElement.querySelector('.price');
            if (priceWrapper) {
                const finalPrice = this.formatCurrency(targetVariant.price);
                if (targetVariant.compare_at_price > targetVariant.price) {
                    const savePercentage = Math.round(((targetVariant.compare_at_price - targetVariant.price) * 100) / targetVariant.compare_at_price);
                    priceWrapper.innerHTML = `<del><span class="amount">${this.formatCurrency(targetVariant.compare_at_price)}</span></del><ins><span class="amount discounted">${finalPrice}</span></ins><small class="unit-price  hidden"><span></span><span class="unit-price-separator">/</span><span></span></small><span class="badges"><span class="badge onsale">Save ${savePercentage}%</span></span>`;
                } else {
                    priceWrapper.innerHTML = `<span class="price-item price-item--regular">${finalPrice}</span>`;
                }
            }
        }
        
        const media = targetVariant.featured_media;
        if (!media) return;

        const flkty = this.productSliderElement ? Flickity.data(this.productSliderElement) : null;
        if (flkty) { flkty.selectCell(`#Slide-${this.sectionId}-${media.id}`, true, false); }
        
        const targetThumb = document.getElementById(`Thumb-${this.sectionId}-${media.id}`);
        if (targetThumb?.parentElement) {
            const parent = targetThumb.parentElement;
            parent.querySelectorAll('.product-thumbnail').forEach(thumb => thumb.classList.remove('is-initial-selected'));
            targetThumb.classList.add('is-initial-selected');
            requestAnimationFrame(() => {
              parent.scrollTo({
                  left: targetThumb.offsetLeft - (parent.clientWidth / 2) + (targetThumb.clientWidth / 2),
                  top: targetThumb.offsetTop - (parent.clientHeight / 2) + (targetThumb.clientHeight / 2),
                  behavior: 'smooth'
              });
            });
        }
      }
      
      toggleSkuHighlight(clickedItem, updateUrl = true, shouldSyncTheme = true) { 
        const isAlreadyHighlighted = clickedItem.classList.contains('is-highlighted'); 
        this.skuItems.forEach(item => { item.classList.remove('is-highlighted'); }); 
        
        if (!isAlreadyHighlighted) { 
          clickedItem.classList.add('is-highlighted'); 
          const variantId = clickedItem.dataset.variantId; 
          if (shouldSyncTheme) this.syncVisualState(variantId); 
          if (updateUrl) this.updateBrowserUrl(variantId); 
          clickedItem.scrollIntoView({ behavior: 'smooth', block: 'center' }); 
        } else { 
          const defaultVariantId = this.allVariantData?.find(v => v.available)?.id || this.allVariantData?.[0]?.id; 
          if (defaultVariantId && shouldSyncTheme) this.syncVisualState(defaultVariantId); 
          if (updateUrl) this.updateBrowserUrl(null); 
        } 
      }
      
      updateBrowserUrl(variantId) { const url = new URL(window.location); if (variantId) { url.searchParams.set('variant', variantId); } else { url.searchParams.delete('variant'); } window.history.pushState({ path: url.href }, '', url.href); }
      handleQuantityButtonClick(button) { const input = button.parentElement.querySelector('.qty-input'); if (!input) return; let currentValue = parseInt(input.value, 10) || 0; if (button.dataset.action === 'increase') { input.value = currentValue + 1; } else if (currentValue > 0) { input.value = currentValue - 1; } this.updateAll(); }
      handleQuantityInputChange(event) { const target = event.target; if (!target.matches('.qty-input')) return; if (parseInt(target.value) < 0 || isNaN(parseInt(target.value))) { target.value = 0; } this.updateAll(); }
      formatCurrency(amount) { try { return new Intl.NumberFormat(document.documentElement.lang, { style: 'currency', currency: this.currencyCode }).format(amount / 100); } catch(e) { return `${(amount / 100).toFixed(2)}`; } }
      
      getActiveDiscountTier(totalPriceCents) {
        if (!this.progressTiers || this.progressTiers.length === 0) return null;
        const sortedTiers = [...this.progressTiers].sort((a, b) => b.amount - a.amount);
        return sortedTiers.find(tier => totalPriceCents >= tier.amount * 100);
      }
      
      updateAll() {
        let pageTotalQuantity = 0;
        let pageSubtotalPriceCents = 0;
        this.skuItems.forEach(item => {
          const input = item.querySelector('.qty-input');
          if (input) {
            const quantity = parseInt(input.value, 10) || 0;
            pageTotalQuantity += quantity;
            if (quantity > 0) {
              pageSubtotalPriceCents += parseInt(item.dataset.basePrice, 10) * quantity;
            }
          }
        });
        this.updateShippingProgress(pageSubtotalPriceCents);
        const activeTier = this.getActiveDiscountTier(this.cartTotalCents + pageSubtotalPriceCents);
        const discountPercent = (activeTier && activeTier.discount_percent) ? parseFloat(activeTier.discount_percent) : 0;
        let finalTotalPriceCents = 0;
        this.skuItems.forEach(item => {
          const basePriceCents = parseInt(item.dataset.basePrice, 10);
          const quantity = parseInt(item.querySelector('.qty-input')?.value, 10) || 0;
          const effectivePriceCents = Math.round(basePriceCents * (1 - discountPercent / 100));
          if (quantity > 0) {
              finalTotalPriceCents += effectivePriceCents * quantity;
          }
          const priceDisplayEl = item.querySelector('.discounted-price');
          const originalPriceEl = item.querySelector('.original-price');
          if (discountPercent > 0 && quantity > 0) {
            priceDisplayEl.textContent = this.formatCurrency(effectivePriceCents);
            priceDisplayEl.classList.add('has-discount');
            originalPriceEl.textContent = this.formatCurrency(basePriceCents);
            originalPriceEl.classList.add('is-discounted');
          } else {
            priceDisplayEl.textContent = this.formatCurrency(basePriceCents);
            priceDisplayEl.classList.remove('has-discount');
            originalPriceEl.classList.remove('is-discounted');
          }
        });
        this.totalItemsEl.textContent = pageTotalQuantity;
        this.totalPriceEl.textContent = this.formatCurrency(finalTotalPriceCents);
        this.addToCartBtn.disabled = pageTotalQuantity === 0;
      }
      
      updateShippingProgress(pageTotalCents) {
          if (!this.progressTiers || this.progressTiers.length === 0) return;
          const combinedTotalCents = this.cartTotalCents + pageTotalCents;
          let progressPercent = 0;
          const tiers = this.progressTiers;
          const startTier = { amount: 0, percent: 0 };
          let lowerTier = startTier;
          let upperTier = null;

          for (let i = 0; i < tiers.length; i++) {
              if (combinedTotalCents >= tiers[i].amount * 100) {
                  lowerTier = tiers[i];
                  upperTier = i < tiers.length - 1 ? tiers[i+1] : null;
              } else {
                  upperTier = tiers[i];
                  break;
              }
          }

          if (upperTier) {
              const lowerAmountCents = lowerTier.amount * 100;
              const upperAmountCents = upperTier.amount * 100;
              const amountRange = upperAmountCents - lowerAmountCents;
              const percentRange = upperTier.percent - lowerTier.percent;
              
              if (amountRange > 0) {
                  progressPercent = lowerTier.percent + ((combinedTotalCents - lowerAmountCents) / amountRange * percentRange);
              } else {
                  progressPercent = (combinedTotalCents >= upperAmountCents) ? upperTier.percent : lowerTier.percent;
              }
          } else if (tiers.length > 0) {
              const lastTier = tiers[tiers.length - 1];
              if (combinedTotalCents >= lastTier.amount * 100) progressPercent = 100;
          }

          progressPercent = Math.min(Math.max(progressPercent, 0), 100);
          if (this.progressBar) this.progressBar.style.width = `${progressPercent}%`;
          
          if (this.currentValueDisplay) {
              this.currentValueDisplay.textContent = this.formatCurrency(combinedTotalCents);
              this.currentValueDisplay.classList.toggle('visible', combinedTotalCents > 0);
              requestAnimationFrame(() => {
                this.currentValueDisplay.style.left = `calc(${progressPercent}% - ${this.currentValueDisplay.offsetWidth / 2}px)`;
              });
          }

          this.milestones.forEach(milestone => milestone.classList.remove('active'));
          const activeTierOnBar = this.getActiveDiscountTier(combinedTotalCents);
          if (activeTierOnBar) {
              const activeStep = Array.from(this.milestones).find(m => m.querySelector('.step-amount').textContent.includes(`$${activeTierOnBar.amount}`));
              if(activeStep) activeStep.classList.add('active');
          }
      }

      handleAddToCart() { if (this.addToCartBtn.classList.contains('loading')) return; this.addToCartBtn.disabled = true; this.addToCartBtn.classList.add('loading'); const btnText = this.addToCartBtn.querySelector('.btn-text'); const spinner = this.addToCartBtn.querySelector('.loading-spinner'); const errorEl = this.container.querySelector('.error-message'); btnText.style.opacity = '0.5'; if (spinner) spinner.style.display = 'block'; if (errorEl) errorEl.style.display = 'none'; const itemsToAdd = []; this.skuItems.forEach(item => { const quantity = parseInt(item.querySelector('.qty-input')?.value, 10); if (quantity > 0) { itemsToAdd.push({ id: item.dataset.variantId, quantity: quantity }); } }); if (itemsToAdd.length === 0) { this.addToCartBtn.disabled = false; this.addToCartBtn.classList.remove('loading'); btnText.style.opacity = '1'; if (spinner) spinner.style.display = 'none'; return; } const body = { items: itemsToAdd, sections: this.getSectionsToRender().map((section) => section.section), sections_url: window.location.pathname }; fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body) }).then(response => response.json()).then(state => { if (state.status >= 400) { throw new Error(state.description || state.message); } this.renderCartContents(state); }).catch(error => { console.error('B2B BLOCK XHR ERROR:', error); if (errorEl) { errorEl.textContent = `Error: ${error.message}`; errorEl.style.display = 'block'; } }).finally(() => { this.addToCartBtn.disabled = false; this.addToCartBtn.classList.remove('loading'); btnText.style.opacity = '1'; if (spinner) spinner.style.display = 'none'; }); }
      getSectionsToRender() { return [{ id: 'Cart-Drawer', section: 'cart-drawer', selector: '.cart-drawer' }, { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-item-count' }]; }
      getSectionInnerHTML(html, selector = '.shopify-section') { return new DOMParser().parseFromString(html, 'text/html').querySelector(selector)?.innerHTML || ''; }
      renderCartContents(parsedState) { this.getSectionsToRender().forEach((section => { const sectionElement = document.getElementById(section.id); if (!sectionElement) return; const elementToReplace = sectionElement.querySelector(section.selector) || sectionElement; if (parsedState.sections?.[section.section]) { elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector); } })); const cartDrawer = document.getElementById('Cart-Drawer'); if (cartDrawer && typeof cartDrawer.open === 'function') { cartDrawer.open(); } else { console.warn('B2B BLOCK: Could not find Cart-Drawer or its open() method.'); } }
    }
  }

  document.querySelectorAll('.b2b-product-block:not([data-initialized])').forEach(container => {
    new window.B2BTieredPricing(container);
  });
  requestAnimationFrame(manageThumbnailOrder);
}

if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', B2B_Price_Component_Initializer); } 
else { B2B_Price_Component_Initializer(); }
document.addEventListener('shopify:section:load', B2B_Price_Component_Initializer);
